export default __webpack_public_path__ + "static/media/008-safety-belt.9e6c67e8.png";